import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';

const fetchRelatedProductsStarted = createAction(
  'booking/fetchRelatedProductsStarted'
);
const fetchRelatedProductsSucceeded = createAction(
  'booking/fetchRelatedProductsSucceeded'
);
const fetchRelatedProductsFailed = createAction(
  'booking/fetchRelatedProductsFailed'
);
const setRelatedProducts = createAction('resources/setRelatedProducts');

const fetchRelatedProducts =
  ({ type, bookingId, limit = 3 }) =>
  (dispatch) => {
    dispatch(fetchRelatedProductsStarted());

    return EcomEngineAPI.booking
      .relatedProducts({ type, bookingId, limit })
      .then((json) => {
        dispatch(fetchRelatedProductsSucceeded());
        dispatch(setRelatedProducts(json));
      })
      .catch((error) => {
        trackError(error);
        dispatch(fetchRelatedProductsFailed(error));
      });
  };

export {
  fetchRelatedProductsStarted,
  fetchRelatedProductsSucceeded,
  fetchRelatedProductsFailed,
  fetchRelatedProducts,
  setRelatedProducts,
};
